import { useState } from "react";
import { H3, Label } from "../Text";
import { toast } from "react-toastify";
import Circle from "../Animation/Circle";
import { Button } from "../Buttons";
import { Request } from "../../hooks/Request";
import TableComplete from "../Tables/TableComplete";
import { requestAuth } from "../services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import CreatableSelect from "react-select/creatable";
import { validateArray } from "../../utils/validate";

const InputSubDataChat = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });

  const {
    data: document,
    loading: loadDocument,
    call: callDocument,
  } = Request({
    urlApi: field.urlApi,
  });

  function handleForm(item) {
    const values = item.description2
      ? JSON.parse(item.description2) || null
      : null;
    console.log("🚀 ~ handleForm ~ item:", values);
    openDialog(
      <>
        {loadDocument && (
          <FormAddDocument
            data={document}
            item={{
              ...item,
              coin: values.coin || "",
              description2: values.Description2 || "",
            }}
            reload={call}
            field={field}
            onClose={dialogClose}
            callDocument={callDocument}
          />
        )}
        <br />
      </>,
    );
  }

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />,
    );
  }

  return (
    <div className="bg-gray-300/40 p-2 rounded-md">
      <Label htmlFor={field.name} className={`${field.className} my-0`}>
        {field.labelCustom ? field.labelCustom : field.label}
      </Label>
      <div className="bg-gray-100 rounded-lg p-3 pt-2">
        {loadDocument && (
          <FormAddDocument
            data={document}
            reload={call}
            field={field}
            onClose={() => {}}
            callDocument={callDocument}
          />
        )}
      </div>
      <br />
      {!loading ? (
        <Circle />
      ) : (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "label",
                label: "Campo",
              },
              {
                name: "description",
                label: "Observación",
              },
              {
                name: "description2",
                label: "NUevo campo",
                type: "custom",
                builder: (item) => {
                  console.log("🚀 ~ InputSubData ~ item:", item);
                  const values = item ? JSON.parse(item) || null : null;
                  console.log("🚀 ~ handleForm ~ values:", values);
                  return (
                    <div className="">
                      {values?.coin ? (
                        <a
                          href={values?.coin}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Enlace
                        </a>
                      ) : null}
                      <h3>{values?.Description2 || "-"}</h3>
                    </div>
                  );
                },
              },
              {
                name: "add",
                type: "action",
                label: "Opciones",
                sticky: true,
                actions: [
                  {
                    label: "Editar",
                    icon: "fas  fa-edit",
                    action: handleForm,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Añadir",
                    icon: "fas fa-trash",
                    action: handleDelete,
                    color: "text-red-500",
                  },
                ],
              },
            ]}
            data={data}
          />
        </div>
      )}
    </div>
  );
};

const FormAddDocument = (props) => {
  const { data, item = null, reload, field, onClose, callDocument } = props;
  const [values, setValues] = useState({
    Label: item?.label ? item.label : validateArray(data) ? data[0].name : "",
    NumberValue: item?.numberValue ? item.numberValue : 0,
    Description: item?.description ? item.description : "",
    Description2: item?.description2 ? item.description2 : "",
    coin: item?.coin ? item.coin : "",
    isNew: false,
  });
  console.log("🚀 ~ FormAddDocument ~ values:", values);

  async function handleSubmit() {
    if (values.isNew) {
      await handleCreateOption(values);
    }
    let formData = new FormData();
    formData.append("Name", values.coin);
    formData.append("File", values.coin);
    formData.append("originalName", values.coin.name);
    // formData.append("Status", "verified");
    // formData.append("ProcedureId", field.id);
    await requestAuth("post", "/files", formData)
      .then(async (res) => {
        console.log("🚀 ~ handleSubmit ~ res:", res);
        // onSubmit({ ...values, url: res.data.url, name: field.label });
        const desc2 = {
          coin: res.data.url || 0,
          Description2: values.Description2,
        };
        await requestAuth(
          item ? "put" : "post",
          item
            ? `/dataSet/procedure/subData/${item.id}`
            : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
          { ...values, Description2: JSON.stringify(desc2) },
        )
          .then(() => {
            reload();
            onClose();
            setValues({
              ...values,
              NumberValue: 0,
              Description: "",
            });
            toast.success("Registro exitoso");
          })
          .catch(() => {
            toast.error("Se produjo un error al guardar");
          });
      })
      .catch(() => {
        toast.error("Se produjo un error al subir el archivo");
      });
  }

  async function handleCreateOption(value) {
    await requestAuth("post", "/Dropdown/Option", {
      Name: value.Label,
      DropdownListLabel: field.urlInitial,
    }).then(() => {
      callDocument();
    });
  }

  function handleChangeInp(e) {
    const { name, value, files, type } = e.target;
    setValues((a) => ({
      ...a,
      [name]: type === "file" ? files[0] : value,
    }));
  }
  function handleChange(e) {
    setValues((a) => ({
      ...a,
      Label: e.value,
      isNew: e.__isNew__ || false,
    }));
  }

  return (
    <form className="flex flex-col">
      <Label className={`mt-2`}>Lista de campos</Label>
      {validateArray(data) ? (
        <CreatableSelect
          isSearchable={true}
          onChange={handleChange}
          styles={{
            placeholder: (base) => ({
              ...base,
              color: "black",
            }),
          }}
          // defaultInputValue={values[field.name]}
          placeholder={"Seleccionar..."}
          isOptionSelected={false}
          // isLoading={field.urlApi ? !loading : false}
          options={data.map((option) => ({
            value: option.name,
            label: option.name,
          }))}
        />
      ) : null}
      <Label className={`my-0 mt-4`}>Observación</Label>
      <div className="flex gap-2">
        <input
          value={values.Description}
          onChange={handleChangeInp}
          className="w-full p-2 rounded-md"
          type="text"
          name="Description"
        />
        111111
        <input
          value={values.Description2}
          onChange={handleChangeInp}
          className="w-full p-2 rounded-md"
          type="text"
          name="Description2"
        />
        <input
          //   value={values.coin}
          onChange={handleChangeInp}
          className="w-full p-2 rounded-md"
          type="file"
          multiple={true}
          name="coin"
        />
        <Button onClick={handleSubmit} className="px-3 py-0">
          Guardar
        </Button>
      </div>
    </form>
  );
};

export default InputSubDataChat;
